module.exports = __webpack_public_path__ + "static/img/netflix-benefit2.d107651.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/netflix-benefit2.png
// module id = 1076
// module chunks = 1